import React, { Component } from "react";
import moment from "moment";
import {
  timelineColor,
  datesObj,
  datesObjState,
  getImagePath,
  colorClass,
  anticipatedTextColors
} from "./projectTimeline.selector";
import { sortBy } from "lodash";

class ProjectTimeline extends Component {
  render() {
    let { projectTimelineData, isProjectAwardedByState } = this.props;
    console.log(isProjectAwardedByState);

    return (
      <React.Fragment>
        {projectTimelineData && projectTimelineData.length
          ? projectTimelineData.map((item, index) => {
              let _color = timelineColor[index % 11];
              let dottedBackground = `repeating-linear-gradient( 90deg, ${_color}, ${_color} 20px, #FAFAFA 20px, #FAFAFA 30px )`;
              let _background =
                item.year > new Date().getFullYear()
                  ? dottedBackground
                  : _color;
              return item.added || item.resolved || item.dates.length ? (
                <div
                  className={`particular-year-data ${colorClass[_color]} 
                  ${
                    item.dates && item.dates.length
                      ? "max-width-auto"
                      : "max-width-200"
                  }
                  ${
                    item.widthIsLess && item.haveMaxDates
                      ? "flex-one"
                      : "flex-auto"
                  }
                  child-${index + 1}
                  `}
                  style={{
                    color: `${_color}`
                    //width: '200px'
                  }}
                >
                  <div className="timeline-year-data">
                    <h3>{item.year}</h3>
                    <div>
                      <div className="issue-added">
                        <span>Issues Added</span>: {item.added}
                      </div>
                      <div className="issue-added">
                        <span>Issues Resolved</span>: {item.resolved}
                      </div>
                    </div>
                  </div>
                  <div
                    className="timeline"
                    style={{ background: `${_background}` }}
                  >
                    <div className="timeline-content">
                      {item.dates && item.dates.length ? (
                        <div className="timeline-items">
                          {sortBy(item.dates, ["date"]).map(
                            (dateItem, innerIndex) => {
                              let position =
                                innerIndex % 2 === 0 ? "keep-up" : "keep-down";
                              let pathForImage = getImagePath(
                                Object.keys(dateItem)[0]
                              );
                              let partiallyCommissionedPercenet =
                                Object.keys(dateItem)[0] ===
                                "partiallyCommissionedDate"
                                  ? item.partiallyCommissionedPercentage
                                  : null;
                              let underConstructionPercent =
                                Object.keys(dateItem)[0] ===
                                "underConstructionDate"
                                  ? item.underConstructionPercentage
                                  : null;

                              let dateColor =
                                Object.keys(dateItem)[0] ===
                                "anticipatedCompletionDate"
                                  ? item.colorForAnticipatedDate
                                  : Object.keys(dateItem)[0] ===
                                    "revisedTargetCompletionDate"
                                  ? item.colorForRevisedDate
                                  : "#000000";
                              return (
                                <div className={`timeline-item ${position}`}>
                                  <div
                                    className={`timeline-date-display ${dateColor} ${
                                      anticipatedTextColors[dateColor]
                                    }`}
                                  >
                                    <span>
                                      {moment(
                                        dateItem[Object.keys(dateItem)[0]]
                                      ).format("Do MMMM")}
                                    </span>
                                    {isProjectAwardedByState == "STATE"
                                      ? datesObjState[Object.keys(dateItem)[0]]
                                      : datesObj[Object.keys(dateItem)[0]]}

                                    {partiallyCommissionedPercenet ||
                                    underConstructionPercent
                                      ? ":"
                                      : null}
                                    {partiallyCommissionedPercenet ? (
                                      <span className="percent-val">
                                        {partiallyCommissionedPercenet}%
                                      </span>
                                    ) : null}
                                    {underConstructionPercent ? (
                                      <span className="percent-val">
                                        {underConstructionPercent}%
                                      </span>
                                    ) : null}
                                  </div>
                                  <div
                                    className="timeline-icon-display"
                                    style={{ border: `1px solid ${_color}` }}
                                  >
                                    <div
                                      style={{
                                        "background-color": `${_color}`
                                      }}
                                    >
                                      <img src={pathForImage} alt="icon" />
                                    </div>
                                  </div>
                                </div>
                              );
                            }
                          )}
                        </div>
                      ) : null}
                    </div>
                  </div>
                </div>
              ) : null;
            })
          : null}
      </React.Fragment>
    );
  }
}

export default ProjectTimeline;
